export default "__VITE_PUBLIC_ASSET__fbc0e057__"